import { render, staticRenderFns } from "./DefaultContents.vue?vue&type=template&id=434915da&scoped=true&"
import script from "./DefaultContents.vue?vue&type=script&lang=js&"
export * from "./DefaultContents.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContents.vue?vue&type=style&index=0&id=434915da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434915da",
  null
  
)

export default component.exports